import React from "react";
import { Link } from "react-router-dom";

const SearchHeader = () => {
  const citiesData = [
    {
      cName: "Chohla Sahib",
    },
    {
      cName: "Sarhali Kalan",
    },
    {
      cName: "Tarn Taran",
    },
    {
      cName: "Amritsar",
    },
    {
      cName: "Sohawa",
    },
  ];
  return (
    <div>
      <nav className="navbar navbar-expand-lg bg-body-tertiary searchNav">
        <div className="container text-dark navbarSearchMobile">
          <Link
            className="navbar-brand fw-semibold text-dark"
            style={{ fontSize: "13px" }}
            to={"/"}
          >
            Get The App
          </Link>
          <button
            className="navbar-toggler hideToggleMobile"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <form className="d-flex justify-content-center mt-2" role="search">
            <input
              className="form-control"
              type="search"
              placeholder="Search"
              aria-label="Search"
              style={{
                borderTopRightRadius: "0px",
                borderBottomRightRadius: "0px",
              }}
            />

            <div className="dropdown">
              <button
                className="btn btn-dark dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                style={{
                  borderTopLeftRadius: "0px",
                  borderBottomLeftRadius: "0px",
                  padding: "6px 23px",
                }}
              >
                Select Area
              </button>
              <ul className="dropdown-menu">
                {citiesData.map((data) => {
                  return (
                    <Link
                      to={"/restaurant"}
                      key={data.cName}
                      style={{ textDecoration: "none" }}
                    >
                      <li>
                        <a className="dropdown-item" href="#">
                          {data.cName}
                        </a>
                      </li>
                    </Link>
                  );
                })}
              </ul>
            </div>
          </form>
          <div
            className="collapse navbar-collapse"
            style={{ flexGrow: "0" }}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav navSearchHeader ms-auto mb-2 mb-lg-0 fw-semibold">
              <li className="nav-item ms-4">
                <Link
                  className="nav-link active text-dark"
                  aria-current="page"
                  to={"/login"}
                  id="loginLink"
                >
                  Log In
                </Link>
              </li>
              <li className="nav-item ms-4">
                <Link
                  className="nav-link active text-dark"
                  aria-current="page"
                  to={"/register"}
                  id="signupLink"
                >
                  Sign up
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  );
};

export default SearchHeader;
